import { DataLayer } from '@core-ui/app-state-provider/types';
import mfeDatalayer from '@mfe/data-layer';

export const datalayerInstance = (): DataLayer => {
  const datalayer = window.gap.datalayer || mfeDatalayer;

  return datalayer;
};
